<h1>Контакты</h1>

<div class="contacts">
  <div class="league">
    <div class="logo">
      <img [src]="league.logo.path"/>
    </div>
    <div class="content">
      <mtg-chips>Лига</mtg-chips>
      <div class="title">{{ league.name }}</div>
      <div class="description">{{ league.description }}</div>
      <div class="param">
        <a href="tel:{{ league.contactPhone }}" class="name">
          <mtg-svg-icon icon="icons-phone"></mtg-svg-icon>
          Телефон
        </a>
        <a class="value" href="tel:{{ league.contactPhone }}">{{ league.contactPhone }}</a>
      </div>
      <div class="param">
        <a href="mailto:{{ league.contactEmail }}" class="name">
          <mtg-svg-icon icon="icons-mail"></mtg-svg-icon>
          Email
        </a>
        <a class="value" href="mailto:{{ league.contactEmail }}">{{ league.contactEmail }}</a>
      </div>
      <div class="param" *ngIf="league.vkLink">
        <a [href]="league.vkLink" target="_blank" class="name">
          <mtg-svg-icon icon="icons-vkontakte"></mtg-svg-icon>
          VK
        </a>
        <a class="value" [href]="league.vkLink" target="_blank">{{ league.vkLink }}</a>
      </div>
      <!--<div class="param" *ngIf="league.fbLink">
        <a [href]="league.fbLink" target="_blank" class="name">
          <mtg-svg-icon icon="icons-facebook"></mtg-svg-icon>
          Facebook
        </a>
        <a class="value" [href]="league.fbLink" target="_blank">{{ league.fbLink }}</a>
      </div>-->
      <div class="param" *ngIf="league.youtubeLink">
        <a [href]="league.youtubeLink" target="_blank" class="name">
          <mtg-svg-icon icon="icons-youtube"></mtg-svg-icon>
          Youtube
        </a>
        <a class="value" [href]="league.youtubeLink" target="_blank">{{ league.youtubeLink }}</a>
      </div>
      <!--<div class="param" *ngIf="league.instaLink">
        <a [href]="league.instaLink" target="_blank" class="name">
          <mtg-svg-icon icon="icons-instagram"></mtg-svg-icon>
          Instagram
        </a>
        <a class="value" [href]="league.instaLink" target="_blank">{{ league.instaLink }}</a>
      </div>-->
      <div class="param" *ngIf="league.telegramLink">
        <a [href]="league.telegramLink" target="_blank" class="name">
          <mtg-svg-icon icon="icons-telegram"></mtg-svg-icon>
          Telegram
        </a>
        <a class="value" [href]="league.telegramLink" target="_blank">{{ league.telegramLink }}</a>
      </div>
      <div class="param" *ngIf="league.tiktokLink">
        <a [href]="league.tiktokLink" target="_blank" class="name">
          <mtg-svg-icon icon="icons-tiktok"></mtg-svg-icon>
          TikTok
        </a>
        <a class="value" [href]="league.tiktokLink" target="_blank">{{ league.tiktokLink }}</a>
      </div>
    </div>
  </div>
  <div class="owner">
    <mtg-chips color="secondary">Организатор</mtg-chips>
    <div class="fullname">{{ league.organization.owner.shortName }}</div>
    <div class="param">
      <mtg-svg-icon icon="icons-phone"></mtg-svg-icon>
      <a href="tel:{{ league.organization.owner.phone }}">{{ league.organization.owner.phone }}</a>
    </div>
    <div class="param">
      <mtg-svg-icon icon="icons-mail"></mtg-svg-icon>
      <a href="mailto:{{ league.organization.owner.email }}">{{ league.organization.owner.email }}</a>
    </div>
  </div>
</div>
